const LOCALHOST = ['localhost', '127.0.0.1']; // TODO: Add dev url
let D360_BASE_URL = 'https://www.flysas.com';
let API_BASE_URL;
let GRAPHQL_BASE_URL;
let ENV;

const { hostname } = window.location;

if (hostname.indexOf('test') > -1 || LOCALHOST.indexOf(hostname) > -1) {
  API_BASE_URL = 'https://test.flysas.com/travel';
  GRAPHQL_BASE_URL = 'https://travelt.sas.se/travel-admin/graphql';
  ENV = 'develop';
} else {
  API_BASE_URL = 'https://www.flysas.com/travel';
  GRAPHQL_BASE_URL = 'https://travel.flysas.com/travel-admin/graphql';
  ENV = 'production';
}

const isPROD = ENV === 'production';

const maptilerKey = 'l15XnJd4sh78OqQ4Mfxo';

const config = {
  API_BASE_URL,
  D360_BASE_URL,
  ENV,
  isPROD,
  GRAPHQL_BASE_URL,
  maptilerKey,
};

export default config;
